import React from 'react';
import { Handshake, Rocket, Brain, Bot, TrendingUp, Users, Award } from 'lucide-react';
import { Reveal, SectionHeading } from '../SectionHeading';

const motives = [
  { icon: Handshake, title: 'Reducing Hiring Friction', desc: 'Pre-vetted pipelines that cut hiring cycles from months to days.' },
  { icon: Rocket, title: 'Faster Workforce Deployment', desc: 'Trained teams live on the ground in as little as 48 hours.' },
  { icon: Brain, title: 'Supporting AI Transformation', desc: 'Human intelligence powering data collection and model training.' },
  { icon: Bot, title: 'Enabling Robotics Operations', desc: 'The human layer behind teleoperation, testing and monitoring.' },
  { icon: TrendingUp, title: 'Enabling Business Growth', desc: 'Elastic workforce that scales exactly with your demand curve.' },
  { icon: Users, title: 'Creating Employment', desc: 'Skilled livelihoods across metros and Tier 2/3 India.' },
  { icon: Award, title: 'Operational Excellence', desc: 'SLA-driven delivery with quality monitoring at every step.' },
];

export const MotiveSection = () => (
  <section data-testid="motive-section" className="py-20 md:py-32 bg-[#0A192F] relative overflow-hidden">
    <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: 'radial-gradient(#4DA3FF 1px, transparent 1px)', backgroundSize: '28px 28px' }} />
    <div className="relative max-w-7xl mx-auto px-6 md:px-12">
      <SectionHeading
        dark
        label="Our Motive"
        title="Building Reliable Workforce Infrastructure for Modern Businesses"
        subtitle="Everything we do exists to remove operational friction — so businesses can focus on growth while we power the execution."
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {motives.map((m, i) => (
          <Reveal key={m.title} delay={i * 0.07}
            className={`p-6 rounded-lg border border-white/10 bg-white/[0.04] backdrop-blur-sm hover:bg-white/[0.08] hover:border-[#4DA3FF]/40 transition-all duration-300 ${i === 6 ? 'sm:col-span-2 lg:col-span-1' : ''}`}>
            <div className="w-11 h-11 rounded-md bg-[#4DA3FF]/15 border border-[#4DA3FF]/25 flex items-center justify-center mb-4">
              <m.icon className="w-5 h-5 text-[#4DA3FF]" />
            </div>
            <h3 className="text-white font-semibold font-heading">{m.title}</h3>
            <p className="text-sm text-slate-400 mt-2 leading-relaxed">{m.desc}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
